import React, { useEffect, useState } from "react";
import api from "../seller-apis/api";
import "./order.css";
import { useAlert } from "react-alert";
import {
  Route,
  Link,
  useLocation,
  Switch,
  NavLink,
  BrowserRouter,
  useRouteMatch,
  Redirect,
  useHistory,
} from "react-router-dom";
import InTransitOrders from "./OrderComponents/InTransit";
import Approved from "./Inventory/Approved";
import Rejected from "./Inventory/Rejected";
import {
  approvedProducts,
  pendforapprovProducts,
  pendingProducts,
  rejectedProducts,
  weightVerification,
  approvedOrProducts,
  draftedProdInitialCount,
  actionRequiredFilter,//SL-968
  weightVerificationFilter,//SL-968
  activeProductFilter,//SL-975
  outOfStockProductFilter,//SL-975
  blockedProductsFilter, // ✅ add this
  getVPriceReqsFilter,

} from "../seller-apis/apidataField";
import NewRequest from "./Inventory/NewRequest";
import NewOfferPrice from "./Inventory/New_Offer_Price";
import { Actions } from "../Actions/Actions";
import { useDispatch, useSelector } from "react-redux";
import store from "../Store";

let productCountsBulkInflight = null;

function Order(props) {
  const history = useHistory();
  const location = useLocation();
  const alert = useAlert();

  // Records for different orders status
  const [approvedRec, setapprovedRec] = useState();
  const [rejectedRec, setrejectedRec] = useState();
  const [pendfappmanual, setpendfappmanual] = useState();
  const [pendfappcatalo, setpendfappcatalo] = useState();
  const [newOfferPriceRec, setnewOfferPriceRec] = useState();
  const [priceverificationtab, setpriceverificationtab] = useState(true);
  const [activeRec, setActiveRec] = useState(0);
  const [outOfStockRec, setOutOfStockRec] = useState();
  const [actionRequired, setActionRRequired] = useState(0);
  const [weightVerificationCnt, setWeightVerificationCnt] = useState(0);
  const [draftedRecord, setDraftedRecords] = useState();
  const [allProducts, setAllProducts] = useState();
  const { path, url } = useRouteMatch();
  const dispatch = useDispatch();
  const productCountsBulkFetchCompleted = useSelector(
    (state) => state.ActionReducer.productCountsBulkFetchCompleted
  );

  useEffect(() => {
    if (localStorage.getItem("vendorState") === "partialInactive") {
      history.replace("/home");
      return;
    }

    if (productCountsBulkFetchCompleted) {
      return;
    }

    if (productCountsBulkInflight) {
      return;
    }

    productCountsBulkInflight = (async () => {
      const pack = {};

      let globalFilter = {
            "pageNo": 1,
            "size":1,
            //SL-975
              status: {
                active: true,
              },
              stockSts: {
                    $or: [
                            {
                            $and:[
                                {
                                    $or:[
                                        {combination : {$exists : false}},
                                        {combination : {$size : 0}}
                                    ]
                                },
                                { 
                                    $or:[
                                        {stock : {$exists : false}},
                                        {stock: 0 }
                                    ]
                                }
                            ]
                            },
                            {
                                combination: {
                                    $elemMatch: {
                                        purchase_price: { $exists: true, $ne: null },
                                        $or: [
                                            { stock: { $exists: false } },
                                            { stock: 0 }
                                            
                                        ]
                                    }
                                }
                                /*$and : [
                                    { combination: { $exists: true, $ne: [] } },
                                    { "combination.purchase_price" : { $exists: true, $ne: null }},
                                    { "combination.stock": 0 },
                                ]*/
                            },
                    ],
              },
              prStatus: {
            $or: [
                    {
                    $and:[
                        {
                        $or:[
                            {combination : {$exists : false}},
                            {combination : {$size : 0}}
                        ]
                        },
                        //{ prSts: {$ne : "V_PENDING" }}
                        {
                            $or:[
                                {prSts: {$exists : true , $ne : "V_PENDING" }},
                                {prSts: {$exists : false }},
                            ]
                        }
                    ]
                    },
                    {
                         
                        $and : [
                            { combination: { $exists: true, $ne: [] } },
                            /*{ "combination.purchase_price" : { $exists: true, $ne: null }},
                            { "combination.prSts": { $ne : "V_PENDING"} },*/
                            {
                                $or:[
                                	{ "combination.prSts": {  $exists: true, $ne : "V_PENDING"} },
                                    { "combination.prSts": {  $exists: false} },
                                ]
                            }
                        ]
                    },
            ],
              },
              weightStatus: {
                      $or: [
                              {
                              $and:[
                                      {
                                          $or:[
                                              {combination : {$exists : false}},
                                              {combination : {$size : 0}}
                                          ]
                                      },
                                      //{  sellerWeightChangeSts: { $ne : "V_PENDING" }}
                                      {
                                          $or:[
                                              { sellerWeightChangeSts: { $exists : true,$ne : "V_PENDING" }},
                                              { sellerWeightChangeSts : {$exists : false }}
                                          ]
                                      }
                              ]
                              },
                              {
                                  $and : [
                                          { combination: { $exists: true, $ne: [] } },
                                          /*{ "combination.purchase_price" : { $exists: true, $ne: null }},
                                          { "combination.sellerWeightChangeSts": { $ne : "V_PENDING" }},*/
                                          {
                                              $or:[
                                                  { "combination.sellerWeightChangeSts": { $exists: true, $ne : "V_PENDING" }},
                                                  { "combination.sellerWeightChangeSts": {  $exists: false} },
                                              ]
                                          }
                                  ]
                              },
                      ],
              }
            
        };

      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

      const tasks = [
        api.product.productsRetrieveall(approvedProducts({
            "pageNo": 1,
            "size": 1,
        })).then((res) => {
              setAllProducts(res.totalRecords);
              pack.allProducts = res.totalRecords;
            })
            .catch((err) => {
                console.log(err);
            }),

        api.product.productsRetrieveall(activeProductFilter({
          "pageNo": 1,
          "size":1,
          status: {
            active: true,
          },
            stockSts: {
                    $or: [
                            {
                              $and:[
                                {
                                  $or:[
                                      {combination : {$exists : false}},
                                      {combination : {$size : 0}}
                                  ]
                                },
                                { stock: {$gt : 0 }}
                              ]
                            },
                            {
                                
                              $and : [
                                { combination: { $exists: true, $ne: [] } },
                                //Has at least one combo with purchase_price & stock > 0
                                { combination: { $elemMatch: { purchase_price: { $exists: true, $ne: null }, stock: { $gt: 0 } } } },
                                //No combo with purchase_price & stock == 0
                                { combination: { $not: { $elemMatch: { purchase_price: { $exists: true, $ne: null }, $or: [{ stock: 0 }, { stock: { $exists: false }}] } } } }
                                //{ "combination.purchase_price" : { $exists: true, $ne: null }},
                                //{ "combination.stock": { $gt : 0 } },
                              ]
                            },
                    ],
            },
            prStatus: {
                    $or: [
                            {
                            $and:[
                                {
                                $or:[
                                    {combination : {$exists : false}},
                                    {combination : {$size : 0}}
                                ]
                                },
                                { prSts: {$ne : "V_PENDING" }}
                            ]
                            },
                            {
                                
                              $and : [
                                  { combination: { $exists: true, $ne: [] } },
                                  { "combination.purchase_price" : { $exists: true, $ne: null }},
                                  { "combination.prSts": { $ne : "V_PENDING"} },
                              ]
                            },
                    ],
            },
            weightStatus: {
                    $or: [
                            {
                            $and:[
                                    {
                                        $or:[
                                            {combination : {$exists : false}},
                                            {combination : {$size : 0}}
                                        ]
                                    },
                                    {  sellerWeightChangeSts: { $ne : "V_PENDING" }}
                            ]
                            },
                            {
                                
                              $and : [
                                      { combination: { $exists: true, $ne: [] } },
                                      { "combination.purchase_price" : { $exists: true, $ne: null }},
                                      { "combination.sellerWeightChangeSts": { $ne : "V_PENDING" }},
                              ]
                            },
                    ],
            }
          
      }))
    .then((res) => {
        setActiveRec(res.totalRecords);
        pack.activeProducts = res.totalRecords;
    })
    .catch((err) => {
        console.log(err);
    }),

      // SL-1221 change action required tab to transfer price change requests
      // api.product.productsRetrieveall(actionRequiredFilter({
      api.product.vPriceReqRetrieveAll(getVPriceReqsFilter({
          pageNo:1,
          size: 1,
          filter:{
              status: "V_PENDING"
          },
          from: "latestVpriceReq"
        //<Start-Here> Ticket : SL-968
        // "prStatus": {
        //     $or: [
        //             {
        //               $and:[
        //                 {
        //                   $or:[
        //                       {combination : {$exists : false}},
        //                       {combination : {$size : 0}}
        //                   ]
        //                 },
        //                 { prSts: "V_PENDING" }
        //               ]
        //             },
        //             {
        //               /*$and : [
        //                 { combination: { $exists: true, $ne: [] } },
        //                 { "combination.purchase_price" : { $exists: true, $ne: null }},
        //                 { "combination.prSts": "V_PENDING" },
        //               ]*/
        //               combination: {
        //                 $elemMatch: {
        //                   purchase_price: { $exists: true, $ne: null },
        //                   prSts: "V_PENDING"
        //                 }
        //               }
        //             },
        //     ],
        // },
        //No need to show products in which vendor's active = false | Ticket : SL-968
        /*
        "status": {
            "active": false
        },*/
        //Need to remove weight verification products form Action Required | Ticket : SL-968
        /*
        "weightStatus": {
            "$or": [
                {
                    "sellerWeightChangeSts": "V_PENDING"
                },
                {
                    "combination.sellerWeightChangeSts": "V_PENDING"
                }
            ]
        }*/
        //</End-Here> Ticket : SL-968
        })).then((res) => {
            setActionRRequired(res.totalRecords);
            pack.actionRequired = res.totalRecords;
        })
        .catch((err) => {
            console.log(err);
        }),

        api.product.productsRetrieveall(weightVerificationFilter({
          "pageNo": 1,
          "size":1,
          //SL-968
          "weightStatus": {
              $or: [
                {
                            
                            $and:[
                                {
                                    $or:[
                                        {combination : {$exists : false}},
                                        {combination : {$size : 0}}
                                    ]
                                },
                                {  sellerWeightChangeSts: "V_PENDING" }
                            ]
                },
                {
                    combination: {
                        $elemMatch: {
                            purchase_price: { $exists: true, $ne: null },
                            sellerWeightChangeSts: "V_PENDING"
                        }
                    }
                            /*$and : [
                            { combination: { $exists: true, $ne: [] } },
                            { "combination.purchase_price" : { $exists: true, $ne: null }},
                            { "combination.sellerWeightChangeSts": "V_PENDING" },
                            ]*/
                },
              ],
          }
      }))
          .then((res) => {
              setWeightVerificationCnt(res.totalRecords);
              pack.weightVerification = res.totalRecords;
          })
          .catch((err) => {
              console.log(err);
          }),

        api.product.productsRetrieveall(outOfStockProductFilter(globalFilter))
            .then((res) => {
                pack.outofstock = res.totalRecords;
                return api.product.getBlockedProductsForSeller(
                    blockedProductsFilter({ pageNo: 1, size: 1, productId: true }, thirtyDaysAgo)
                );
            })
            .then((res) => {
                pack.blockedProducts = res.totalRecords || 0;
            })
            .catch((err) => {
                console.log(err);
            }),

        api.product
          .productsRetrieveall(
            approvedProducts({
              pageNo: 1,
              size: 1,
              prStatus: {
                prSts: { $exists: false },
              },
              status: {
                vActive: "ACTIVE",
              },
            })
          )
          .then((res) => {
            setnewOfferPriceRec(res.totalRecords);
            if (res.totalRecords < 1) {
              Actions.HidePriceVerification(dispatch, false);
              setpriceverificationtab(false);
            }
          })
          .catch((err) => {
            console.log(err);
          }),
      ];

      const results = await Promise.allSettled(tasks);
      results.forEach((r) => {
        if (r.status === "rejected") {
          console.log(r.reason);
        }
      });

      const prev = store.getState().ActionReducer.inventoryCount || {};
      const ap = Number(pack.activeProducts) || 0;
      const ar = Number(pack.actionRequired) || 0;
      const wv = Number(pack.weightVerification) || 0;
      Actions.InventoryCountAction(dispatch, {
        ...prev,
        ...pack,
        approved: ap + ar + wv,
      });
    })().finally(() => {
      productCountsBulkInflight = null;
      Actions.productCountsBulkFetchComplete(dispatch);
    });
  }, [dispatch, history, productCountsBulkFetchCompleted]);

  useEffect(() => {
    const base = store.getState().ActionReducer.inventoryCount || {};
    Actions.InventoryCountAction(dispatch, {
      ...base,
      approved:
        (parseInt(activeRec, 10) || 0) +
        (parseInt(actionRequired, 10) || 0) +
        (parseInt(weightVerificationCnt, 10) || 0),
    });
  }, [activeRec, actionRequired, weightVerificationCnt, allProducts, dispatch]);

  useEffect(() => {
    const base = store.getState().ActionReducer.inventoryCount || {};
    Actions.InventoryCountAction(dispatch, {
      ...base,
      new:
        (parseInt(pendfappmanual, 10) || 0) +
        (parseInt(pendfappcatalo, 10) || 0) +
        (parseInt(rejectedRec, 10) || 0) +
        (parseInt(draftedRecord, 10) || 0),
    });
  }, [pendfappmanual, pendfappcatalo, rejectedRec, draftedRecord, dispatch]);


  return (
    <>
      <div className="filter_options_invent order_nav_cntn d-flex tab">
        {/* <div className="ord_table" style={{ width: "100%" }}>
          <NavLink to={`${path}/approved`} className="invent_nav">
            <button className="filter_options_btn_invent me-2">
              Approved Products ({approvedRec})
            </button>
          </NavLink>
          <NavLink to={`${url}/new_product_request`} className="invent_nav">
            <button className="filter_options_btn_invent me-2">
              New Product request (
              {parseInt(pendfappcatalo) + parseInt(pendfappmanual)})
            </button>
          </NavLink>
          {priceverificationtab ? (
            <NavLink exact to={`${url}/new_offer_price`} className="invent_nav">
              <button className="filter_options_btn_invent me-2 border-2 border-danger text-danger fs-10 new_offer_btn_invent">
                Price Verification Pending({newOfferPriceRec})
              </button>
            </NavLink>
          ) : (
            <></>
          )}
        </div> */}
      </div>
      {/* Routes */}
      <div>
        <Route exact path="/my-inventory">
          <Redirect to={`${path}/approved`} />
        </Route>
        <Route path={`${path}/approved`} component={Approved} />
        <Route path={`${path}/new_product_request`} component={NewRequest} />
        <Route path={`${path}/new_offer_price`} component={NewOfferPrice} />
      </div>
    </>
  );
}

export default Order;
